@if (ProposalRequestVendor && ProposalRequest && ProposalRequestAddress) {
  <div class="container-fluid">
    <div class="row row-padding">
      @if (ProposalRequest.name) {
        <div class="col">
          <label class="title-label"
            >QuickSourceBids {{ '- '.concat(ProposalRequest.name) }}</label
          >
        </div>
      }
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="row row-padding">
          <div class="col">
            <app-display-card>
              <div class="row">
                <div class="col">
                  <label class="card-title">Bid Details</label>
                </div>
              </div>
              <div class="row row-padding">
                <div class="col">
                  <div class="inner-panel rounded">
                    <div class="row">
                      <div class="col">
                        <label class="section-title">Bid Dates</label>
                      </div>
                    </div>
                    <div class="row row-padding">
                      <div class="col-md-6">
                        <div class="row">
                          <div class="col-md-6">
                            <label>Reminder Date:</label>
                          </div>
                          <div class="col-md-6">
                            <label class="content-label">{{
                              ProposalRequest.reminderDate | date: 'MM/dd/y'
                            }}</label>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="row">
                          <div class="col-md-6">
                            <label>Due Date:</label>
                          </div>
                          <div class="col-md-6">
                            <label class="content-label">{{
                              ProposalRequest.dueDate | date: 'MM/dd/y'
                            }}</label>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="row">
                          <div class="col-md-6">
                            <label>Project Start Date:</label>
                          </div>
                          <div class="col-md-6">
                            <label class="content-label">{{
                              ProposalRequest.startDate | date: 'MM/dd/y'
                            }}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row row-padding">
                <div class="col">
                  <div class="inner-panel rounded">
                    <div class="row">
                      <div class="col">
                        <label class="section-title"
                          >Work Location Details</label
                        >
                      </div>
                    </div>
                    <div class="row row-padding">
                      <div class="col">
                        <div class="row">
                          <div class="col-auto">
                            <label>Address:</label>
                          </div>
                          <div class="col">
                            <label class="content-label">
                              {{ ProposalRequestAddress.address1 }}
                              {{ ProposalRequestAddress.address2 }}
                              {{ ProposalRequestAddress.city }},
                              {{ ProposalRequestAddress.state }}
                              {{ ProposalRequestAddress.zip }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row row-padding">
                <div class="col">
                  <div class="inner-panel rounded">
                    <div class="row">
                      <div class="col">
                        <label class="section-title">Contact Details</label>
                      </div>
                    </div>
                    <div class="row row-padding">
                      <div class="col-md-6">
                        <div class="row">
                          <div class="col-md-6">
                            <label>Name:</label>
                          </div>
                          <div class="col-md-6">
                            <label class="content-label"
                              >{{ ProposalRequest.contactFirstName }}
                              {{ ProposalRequest.contactLastName }}</label
                            >
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="row">
                          <div class="col-md-6">
                            <label>Mobile Phone:</label>
                          </div>
                          <div class="col-md-6">
                            <label class="content-label">{{
                              ProposalRequest.contactPhone
                            }}</label>
                          </div>
                        </div>
                      </div>
                      @if (ProposalRequest.contactPhone2) {
                        <div class="col-md-6">
                          <div class="row">
                            <div class="col-md-6">
                              <label>Work Phone:</label>
                            </div>
                            <div class="col-md-6">
                              <label class="content-label">{{
                                ProposalRequest.contactPhone2
                              }}</label>
                            </div>
                          </div>
                        </div>
                      }
                      <div class="col-md-12">
                        <div class="row">
                          <div class="col-md-3">
                            <label>Email:</label>
                          </div>
                          <div class="col-md-3">
                            <label class="content-label">{{
                              ProposalRequest.contactEmail
                            }}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              @if (ProposalRequest.instructions) {
                <div class="row row-padding">
                  <div class="col">
                    <div class="inner-panel rounded">
                      <div class="row">
                        <div class="col">
                          <label class="section-title">Bid Instructions</label>
                        </div>
                      </div>
                      <div class="row row-padding">
                        <div class="col-md-12">
                          <p>{{ ProposalRequest.instructions }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
              @if (
                ProposalRequest.ProposalRequestFiles &&
                ProposalRequest.ProposalRequestFiles.length > 0
              ) {
                <div class="row row-padding">
                  <div class="col">
                    <div class="inner-panel rounded">
                      <div class="row">
                        <div class="col">
                          <label class="section-title"
                            >Proposal Documents</label
                          >
                        </div>
                      </div>
                      <div class="row row-padding">
                        @for (
                          ProposalRequestFile of ProposalRequest.ProposalRequestFiles;
                          track ProposalRequestFile
                        ) {
                          @if (ProposalRequestFile.File) {
                            <div class="row">
                              <div class="col-md-6">
                                <label>{{
                                  ProposalRequestFile.File.filename
                                }}</label>
                              </div>
                              <div class="col-md-6">
                                <a
                                  href="javascript:void(0)"
                                  (click)="
                                    downloadFile(
                                      ProposalRequestFile.File,
                                      'ProposalRequestFile'
                                    )
                                  "
                                  class="cursor-select no-underline vive-blue"
                                >
                                  <i class="vive-blue bi bi-box-arrow-down"></i>
                                  Download File
                                </a>
                              </div>
                            </div>
                          }
                        }
                      </div>
                    </div>
                  </div>
                </div>
              }
            </app-display-card>
          </div>
        </div>
      </div>
      <form class="col-md-6" [formGroup]="ProposalRequestVendorFormGroup">
        <div class="row" formGroupName="Proposal">
          <div class="col">
            <div class="row row-padding">
              <div class="col-12">
                @if (
                  !LoggedInUser ||
                  LoggedInUser.UserAccountType?.name === 'Vendor'
                ) {
                  <label class="section-title">Bid Response</label>
                }
                @if (
                  LoggedInUser &&
                  LoggedInUser.UserAccountType?.name !== 'Vendor'
                ) {
                  <label class="section-title"
                    >Submit Bid on Behalf of
                    {{ ProposalRequestVendor.legalName }}</label
                  >
                }
              </div>
              @if (
                !LoggedInUser || LoggedInUser.UserAccountType?.name === 'Vendor'
              ) {
                <div class="col-12">
                  <p>
                    On the left is a summary of the proposal your client is
                    requesting you to bid. Contact, location and proposal
                    details can be found there. You may bid in the form below,
                    attach a bid to submit or decline to bid on this proposal.
                  </p>
                </div>
              }
            </div>
            <div class="row row-padding">
              <div class="col-md-6">
                <div class="row">
                  <div class="col">
                    <label class="form-label">Proposed Start Date</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="input-group">
                      <input
                        class="form-control"
                        type="text"
                        (ngModelChange)="startDateChanged()"
                        placeholder="MM/DD/YYYY"
                        formControlName="workStartDate"
                        [minDate]="minDatePickerStartDate"
                        navigation="select"
                        ngbDatepicker
                        container="body"
                        #startDatePicker="ngbDatepicker"
                        appNgbDateInputMask
                      />
                      <button
                        class="btn btn-primary datepicker-button btn-outline-secondary bi bi-calendar"
                        (click)="startDatePicker.toggle()"
                        type="button"
                      ></button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row">
                  <div class="col">
                    <label class="form-label">Proposed End Date</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="input-group">
                      <input
                        class="form-control"
                        type="text"
                        placeholder="MM/DD/YYYY"
                        formControlName="workFinishDate"
                        [minDate]="minDatePickerEndDate"
                        navigation="select"
                        ngbDatepicker
                        container="body"
                        #endDatePicker="ngbDatepicker"
                        appNgbDateInputMask
                      />
                      <button
                        class="btn btn-primary datepicker-button btn-outline-secondary bi bi-calendar"
                        (click)="endDatePicker.toggle()"
                        type="button"
                      ></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            @if (
              ProposalLineItems.controls.length > 0 &&
              ProposalRequest.ProposalRequestLineItems
            ) {
              <p class="mt-3 mb-0">
                Please itemize the bid into the following cost categories, as
                requested by the client.
              </p>
              @for (
                lineItem of ProposalLineItems.controls;
                track lineItem;
                let i = $index
              ) {
                <div class="row row-padding" [formGroup]="lineItem">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col">
                        <label class="form-label" requiredAsterisk>{{
                          ProposalRequestLineItemsMappedById.get(
                            lineItem.value.ProposalRequestLineItemId!
                          )!.text
                        }}</label>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <div class="input-group">
                          <span class="input-group-text">$</span>
                          <input
                            type="number"
                            class="form-control"
                            formControlName="text"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            }
            <div class="row row-padding">
              <div class="col-md-12">
                <div class="row">
                  <div class="col">
                    <label class="form-label"
                      >Total Price (excluding tax)</label
                    >
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="input-group">
                      <span class="input-group-text">$</span>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="totalPrice"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row row-padding">
              <div class="col-12">
                @if (
                  !LoggedInUser ||
                  LoggedInUser.UserAccountType?.name === 'Vendor'
                ) {
                  <label class="section-title">Bid Comments</label>
                }
                @if (
                  LoggedInUser &&
                  LoggedInUser.UserAccountType?.name !== 'Vendor'
                ) {
                  <label class="section-title">Bid Details</label>
                }
              </div>
              @if (
                !LoggedInUser || LoggedInUser.UserAccountType?.name === 'Vendor'
              ) {
                <div class="col-12">
                  <p>
                    You may submit supporting comments and/or attach supporting
                    documents to your bid below. You are
                    <span class="bold">REQUIRED</span> to enter in comments
                    and/or attach supporting documents in order to submit your
                    bid.
                  </p>
                </div>
              }
              <div class="col-12">
                <textarea
                  class="form-control"
                  formControlName="comments"
                ></textarea>
              </div>
            </div>
            @if (
              !isProposalRequestInFinishedState() ||
              (isProposalRequestInFinishedState() &&
                getFilesFromProposalFormGroup().length > 0)
            ) {
              <div class="row row-padding">
                <div class="col-12">
                  <label class="section-title">Bid Documents</label>
                </div>
                <div class="col-12">
                  <p [ngClass]="{ 'error-red': fileErrors['isFileTooBig'] }">
                    Maximum file size of 10MB per file and 25MB total for all
                    files.
                  </p>
                </div>
                @if (
                  !LoggedInUser ||
                  LoggedInUser.UserAccountType?.name === 'Vendor'
                ) {
                  <div class="col-12">
                    <p>
                      Due to email size limits set by various email service
                      providers (e.g. Gmail), There is a maximum file size of
                      10MB per file, and 25MB total for all files attached to a
                      bid. If your bid contains a considerable amount of photos,
                      please consider lowering the resolution and/or resize the
                      images to reduce the size of your files.
                    </p>
                  </div>
                }
                <div class="col-12">
                  <app-file-upload-file-display
                    [layout]="'vertical'"
                    [hideSelectFileButton]="true"
                    [Files]="getFilesFromProposalFormGroup()"
                    [showFileType]="false"
                    [displayOnly]="isProposalRequestInFinishedState()"
                    (FileEvent)="fileUpload($event)"
                    (removeFileEvent)="removeProposalRequestFile($event)"
                    (downloadFileEvent)="
                      downloadFile(castToFileModel($event), 'ProposalFile')
                    "
                  ></app-file-upload-file-display>
                </div>
              </div>
            }
            @if (
              errors &&
              errors['Proposal'] &&
              errors['Proposal']['commentFiles'] &&
              !ProposalRequestVendorFormGroup.controls['Proposal']!.value
                .comments &&
              ProposalRequestVendorFormGroup.controls['Proposal']!.controls[
                'ProposalFiles'
              ].length === 0
            ) {
              <div class="row row-padding-bottom">
                <label class="error-red"
                  >You must add a bid comment or upload at least one bid
                  document.</label
                >
              </div>
            }
            @if (!this.isProposalRequestInFinishedState()) {
              <div class="row row-padding-bottom">
                <div class="col">
                  <button class="btn btn-primary" (click)="navigateBack()">
                    Back
                  </button>
                </div>
                <div class="col">
                  <button class="btn btn-danger" (click)="declineProposal()">
                    Decline to bid
                  </button>
                </div>
                <div class="col">
                  <button class="btn btn-primary" (click)="submitProposal()">
                    Submit bid
                  </button>
                </div>
              </div>
            }
          </div>
        </div>
      </form>
    </div>
  </div>
}
